module.exports = __webpack_public_path__ + "static/media/onboarding-shop.e2dce2a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboarding-shop.svg
// module id = 362
// module chunks = 0